import React from "react";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

const handleRenderOption = (option, { inputValue }) => {
  let nombre = option?.Cliente?.Nombre
  const matches = match(`${option?.IdCotizacion} - ${nombre} (${option?.Cliente?.EMail})`, inputValue);
  const parts = parse(`${option?.IdCotizacion} - ${nombre} (${option?.Cliente?.EMail})`, matches);
  const highlightStyle = {
    fontWeight: 700,
    backgroundColor: "lightyellow",
    padding: "5px 2px",
  };
  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </div>
  );
};

export default handleRenderOption;
